<template>
  <div class="carResultAssessment">

    <div class="back icon topBackground">
      <div class="title flex-center">{{title}}</div>
      <div class="flex-between main">
        <div class="flex-start">
          <span class="caricon icon"></span>{{ list.plateNumber }}
        </div>
        <div class="flex-start">评估师：{{ list.appraiser }}</div>
      </div>
    </div>

    <div class="detail">
      <div class="top flex-start">
        <img :src="list.brandLogo" alt="">
<!--        <img src="../../image/carResultAssessment/car.png" alt="">-->
        <div>
          <div class="flex-between">
            <span>{{ list.seriesName }}</span>
<!--            <div>{{ list.usedCarName }}</div>-->
          </div>
          <div>{{ list.usedCarName }}</div>
          <div>车架号：{{ list.vin }}</div>
          <div class="flex-start">{{ list.customerName }}<div class="phone">{{ list.customerPhone }}</div></div>
        </div>
      </div>
      <div class="top2 flex-center">
        <div>
          <div>{{ this.formatDate(list.registrationTime,'yyyy-MM-dd') }}</div>
          <div>首次上牌</div>
        </div>
        <div>
          <div>{{ list.changeNum }}</div>
          <div>过户次数</div>
        </div>
        <div>
          <div>{{ list.mileage }}万公里</div>
          <div>行驶里程</div>
        </div>
        <div>
          <div>{{ list.emissionStandardShowName }}</div>
          <div>排放标准</div>
        </div>
      </div>
    </div>

    <div class="carBack icon">
      <span class="flex-center">车况评估结果</span>
    </div>

    <!--评估价格-->
    <div class="condition">
      <div class="flex-start title">
        <div class="flex-start">评估价格(万元)：
          <span>{{ (list.evaluationPrice/10000).toFixed(2) }}</span>
          <span>~</span>
          <span>{{ (list.evaluationMaxPrice/10000).toFixed(2) }}</span>
        </div>
      </div>
      <div class="icon staicon" :class="ass.totalGrades=='精品'?'ydemo1':''+ass.totalGrades=='优秀'?'ydemo2':''+ass.totalGrades=='良好'?'ydemo3':''+ass.totalGrades=='一般'?'ydemo4':''">
        <div>
          <div class="points flex-center"><span>{{ ass.totalScore }}</span>分</div>
          <div class="sta" :style="'color:'+ ass.color">{{ ass.totalGrades }}</div>
        </div>
      </div>
      <div class="ul flex-center">
        <div class="li" v-for="(item, index) in ass.assessmentConfigs">
          <div :style="'color:'+ item.color">{{item.score}}<span style="font-size: .1rem">({{item.grades}})</span></div>
          <div>{{ item.assessmentName }}</div>
        </div>
      </div>
      <!--综合评价-->
      <div class="evaluate">
        <div class="toptitle">综合评价</div>
        <div class="main">{{ list.evaluation }}</div>
        <div class="time">评估时间：{{this.formatDate(list.evaluationTime,'yyyy-MM-dd hh:mm:ss')}}</div>
        <div class="demo1 icon staicon" v-if="ass.totalGrades=='精品'"></div>
        <div class="demo2 icon staicon" v-if="ass.totalGrades=='优秀'"></div>
        <div class="demo3 icon staicon" v-if="ass.totalGrades=='良好'"></div>
        <div class="demo4 icon staicon" v-if="ass.totalGrades=='一般'"></div>
      </div>
    </div>

    <!--车辆实拍-->
    <div class="table">
      <div class="pageTit">车辆实拍</div>
      <div class="box2">
        <div class="tabTit flex-center">
          <div v-for="(item,index) in ['外观','内饰']" class="flex-center" :class="tabTitIndex==index?'act':''" @click="seletab2(index)">{{item}}</div>
        </div>
        <div v-if="tabTitIndex==0" class="imgList flex-center" style="flex-wrap: wrap;padding: 0 .21rem">
          <img :src="item" preview="w0" preview-text="外观" style="width: 2.85rem;height: 2rem;margin: .05rem;" :style="!moreSta&&index>2?'display:none;':''" v-for="(item,index) in list.evaluationSheetDetailVO.outsideImage">
        </div>
        <div v-if="tabTitIndex==1" class="imgList flex-center" style="flex-wrap: wrap;padding: 0 .21rem">
          <img :src="item" preview="n0" preview-text="内饰" style="width: 2.85rem;height: 2rem;margin: .05rem;" :style="!moreSta&&index>2?'display:none;':''" v-for="(item,index) in list.evaluationSheetDetailVO.insideImage">
        </div>
        <div class="flex-center seeMore" @click="seletab3()">
          查看更多
          <img v-if="moreSta" src="../../image/triangle.png" alt="" style="width: .15rem;transform: rotate(90deg);margin-left: .14rem">
          <img v-if="!moreSta" src="../../image/triangle.png" alt="" style="width: .15rem;transform: rotate(-90deg);margin-left: .14rem">
        </div>
      </div>
    </div>

    <div class="table">
      <div class="ul">
        <div class="li flex-center" :class="indextab==index?'act':''" v-for="(item, index) in config" @click="seletab(index)">
          {{ item.firstItemName }} <span></span>
        </div>
      </div>

      <div class="detail2">
        <div class="one flex-between">
          <div>{{ configList.firstItemName }}</div>
          <span v-if="configList.abnormalCount > 0">{{ configList.abnormalCount }}项异常</span>
          <span v-else>0 项异常</span>
        </div>
        <div class="two flex-between" :style="item.isNormal?'display:none;':''" v-for="(item, index) in configList.secondItems">
          <div>{{ item.secondItemName }}</div>
          <div class="flex-start">{{ item.itemValue }} <span class="err icon" v-if="!item.isNormal"></span>
            <div style="width: 100%;position: absolute;left: 0;height: 100%;top: 0;overflow: hidden;opacity: 0;">
              <img :src="it" :preview="'t'+index" :preview-text="item.secondItemName+'  '+item.itemValue" v-for="(it) in item.itemImgs">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table">
      <div class="pageTit">评估师</div>
      <div class="box">
        <div class="flex-start" style="margin: 0 .56rem;padding: .4rem 0 .28rem;border-bottom: .03rem solid #F0F0F0">
          <img :src="list.evaluationSheetDetailVO.creator.headPortrait" alt="" style="width: 1.75rem;height: 1.75rem;margin-right: .3rem;border-radius: .25rem">
          <div class="info">
            <div class="name flex-start" style="flex-wrap: wrap;">{{ list.evaluationSheetDetailVO.creator.name }} <div style="margin-left: .21rem">{{ list.evaluationSheetDetailVO.creator.mobile }}</div></div>
            <div class="flex-start intip">
              <div class="pgs1 pgsIcon1"></div>
              <div>{{ list.evaluationSheetDetailVO.creator.shop.shopName }}</div>
            </div>
            <div class="flex-start intip">
              <div class="pgs1 pgsIcon2"></div>
              <div>{{ list.evaluationSheetDetailVO.creator.shop.phone }}</div>
            </div>
            <div class="flex-start intip" style="align-items: flex-start">
              <div class="pgs1 pgsIcon3"></div>
              <div style="width: 4.95rem;">{{ list.evaluationSheetDetailVO.creator.shop.address }}</div>
            </div>
          </div>
        </div>
        <div class="btn flex-center">
          <div class="flex-center" @click="callPhone(list.evaluationSheetDetailVO.creator.shop.phone)">
            <div class="pgs2 pgsIcon4"></div>致电店铺
          </div>
          <div class="flex-center" @click="callPhone(list.evaluationSheetDetailVO.creator.mobile)">
            <div class="pgs2 pgsIcon5"></div>致电评估师
          </div>
        </div>
      </div>
    </div>
    <!--签名-->
    <div class="signature">
      <div style="font-size: .33rem;padding: .7rem .3rem 0;">根据以上评估报告，上述车辆价格有效期到<span style="color: #EA0E0E">{{ this.formatDate(list.evaluationSheetDetailVO.termOfValidity,'yyyy-MM-dd') }}</span>止，我在此声明：我是上述车辆产权拥有者，并保证上述车辆的装备和附件不得被拆、调换或损坏，行驶公里数不得超过<span style="color: #EA0E0E">{{ list.evaluationSheetDetailVO.limitedKilometers }}</span>公里，车辆的事故情况、里程表数据和总行驶里程全部属实。</div>
      <!--客户确认-->
      <div style="text-align: center;padding-bottom: .3rem;">
        <div class="title flex-start">客户确认</div>
        <img v-bind:src="list.evaluationSheetDetailVO.customerSignature" alt="">
        <!--评估师签名-->
        <div class="title flex-start">评估师签名</div>
        <img v-bind:src="list.evaluationSheetDetailVO.appraiserSignature" alt="">
        <!--二手车经理/销售经理签名-->
<!--        <div class="title flex-start">二手车经理/销售经理签名</div>-->
<!--        <img v-bind:src="list.evaluationSheetDetailVO.managerSignature" alt="">-->
      </div>
    </div>

    <div class="tip flex-end">* 以上结果仅对本次评估有效，最终解释权归车多会所有</div>

  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      title: '爱车评估结果',
      indextab: 0,
      id: '',
      list: '',
      ass: '',
      config: '',
      configList: [],

      tabTitIndex: 0,
      moreSta: false,
    };
  },
  methods: {
    formatDate(time, format) {

      let t = new Date(time);

      if (format.indexOf("yyyy") >= 0) {
        format = format.replace("yyyy", t.getFullYear())
      }
      else if (format.indexOf("yy") >= 0) {
        format = format.replace("yy", (t.getFullYear() + "").substring(2));
      }

      let formatMapping = {
        M: (t.getMonth() + 1),
        m: t.getMinutes(),
        d: t.getDate(),
        h: t.getHours(),
        s: t.getSeconds()
      }

      let keys = Object.keys(formatMapping);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (format.indexOf(key + key) >= 0) {
          let result = formatMapping[key];
          format = format.replace(key + key, (result + "").length == 2 ? result : "0" + result);
        } else if (format.indexOf(key) >= 0) {
          format = format.replace(key, formatMapping[key]);
        }
      }

      return format;
    },
    seletab(index) {
      // console.log(index)
      this.indextab = index;
      this.configList = this.config[index]

      this.$previewRefresh()
    },
    seletab2(index) {
      this.tabTitIndex = index;
      this.moreSta = false

      this.$previewRefresh()
    },
    seletab3() {
      this.moreSta = !this.moreSta
    },
    callPhone (phoneNumber) {
      window.location.href = 'tel://' + phoneNumber
    },
    detail(){
      let _this = this;
      request({
        url: '/electronic_form/evaluation_sheet/share_record/detail',
        method: 'GET',
        data:{
          id:_this.id,
        }
      }).then(res=>{
        console.log(res.data)
        if(res.data.brandLogo.indexOf('http') == -1) {
          res.data.brandLogo = 'http://cdn1.daihing.yn-ce.com/'+res.data.brandLogo
        }
        if(!res.data.evaluationPrice && !res.data.evaluationMaxPrice) {
          res.data.evaluationPrice = 0
          res.data.evaluationMaxPrice = 0
        }else if(!res.data.evaluationPrice) {
          res.data.evaluationPrice = res.data.evaluationMaxPrice
        }else if(!res.data.evaluationMaxPrice) {
          res.data.evaluationMaxPrice = res.data.evaluationPrice
        }
        _this.list = res.data

        let re = res.data.assessmentItems
        re.totalScores.forEach(item =>{
          if(item.grades == re.totalGrades) {
            re.color = item.color
          }
        })
        _this.ass = re

        let list = res.data.configItems
        _this.config = list
        _this.configList = list[0]

        _this.$previewRefresh()
      })
    },
  },
  mounted: function () {
    let id = window.location.href
    id = id.split('?id=')
    // console.log(id,'id',id[1])
    this.id = id[1]
    this.detail();
  }
};
</script>

<style lang="less">
body {
  background: #F1F1F1;
}
.flex-center{
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:center;
}
.flex-start{
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:flex-start;
}
.flex-end{
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:flex-end;
}
.flex-between{
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:space-between;
}
.flex-around{
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:space-around;
}

img {
  width: 100%;
}
.icon {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.back {
  background-image: url("../../image/carResultAssessment/back.png");
}
.carBack {
  background-image: url("../../image/carResultAssessment/carBack.png");
  width: 100%;
  height: 2rem;
}
.caricon {
  background-image: url("../../image/carResultAssessment/caricon.png");
  width: .69rem;
  height: .69rem;
  margin-right: .2rem;
}
.err {
  background-image: url("../../image/carResultAssessment/err.png");
}
.demo1 {
  background-image: url("../../image/carResultAssessment/Boutique.png");
}
.demo2 {
  background-image: url("../../image/carResultAssessment/excellent.png");
}
.demo3 {
  background-image: url("../../image/carResultAssessment/good.png");
}
.demo4 {
  background-image: url("../../image/carResultAssessment/ordinary.png");
}
.ydemo1 {
  background-image: url("../../image/carResultAssessment/yBoutique.png");
}
.ydemo2 {
  background-image: url("../../image/carResultAssessment/yexcellent.png");
}
.ydemo3 {
  background-image: url("../../image/carResultAssessment/ygood.png");
}
.ydemo4 {
  background-image: url("../../image/carResultAssessment/yordinary.png");
}
.pgs1 {
  width: .3rem;
  height: .3rem;
  margin-right: .13rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pgs2 {
  width: .5rem;
  height: .5rem;
  margin-right: .13rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pgsIcon1 {
  background-image: url("../../image/carResultAssessment/demo1.png");
}
.pgsIcon2 {
  background-image: url("../../image/carResultAssessment/demo2.png");
}
.pgsIcon3 {
  background-image: url("../../image/carResultAssessment/demo3.png");
}
.pgsIcon4 {
  background-image: url("../../image/carResultAssessment/demo4.png");
}
.pgsIcon5 {
  background-image: url("../../image/carResultAssessment/demo5.png");
}


.topBackground {
  height: 5.6rem;
}
.topBackground .title {
  font-weight: 500;
  color: #FFFFFF;
  line-height: .45rem;
  font-size: .45rem;
  height: 1.0668rem;
}
.topBackground .main {
  padding: 0 .33rem;
  font-size: .4rem;
  font-weight: 500;
  color: #FFFFFF;
  line-height: .4rem;
  height: 1.7335rem;
}

.detail {
  width: 9.33rem;
  background: #FFFFFF;
  box-shadow: 0 0.02667rem 0.26667rem 0 rgb(0 0 0 8%);
  border-radius: 0.16rem;
  margin: -2.82667rem auto 0;
}
.detail .top {
  padding: 0.4rem;
  font-size: 0.34667rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #626262;
  line-height: 0.34667rem;
}
.detail .top img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.4rem;
}
.detail .top span {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #323232;
}
.detail .top> div {
  width: 100%;
}
.detail .top> div> div {
  margin-top: 0.32rem;
}
.detail .top> div> div:nth-child(1) {
  margin-top: 0;
}
.detail .top .phone {
  margin-left: 0.72rem;
}

.detail .top2 {
  text-align: center;
  height: 1.92rem;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #323232;
  line-height: 0.32rem;
}
.detail .top2> div {
  width: 100%;
}
.detail .top2> div> div:nth-child(1){
  margin-bottom: 0.4rem;
}
.carBack span{
  height: 2rem;
  font-size: 0.42667rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #323232;
  line-height: 0.42667rem;
  padding-left: 20%;
}

.condition {
  width: 9.33333rem;
  background: #FFFFFF;
  box-shadow: 0 0.02667rem 0.26667rem 0 rgb(0 0 0 8%);
  border-radius: 0.13333rem;
  margin: 0 auto;
}
.condition .title {
  height: 1.92rem;
  border-bottom: 0.02667rem solid #EAEAEA;
  margin: 0 0.21333rem;
  padding: 0 0.16rem;
}
.condition .title> div {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #323232;
  line-height: 0.4rem;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
}
.condition .title span{
  font-size: 0.7rem;
  color: #EA3810;
  line-height: 0.7rem;
}
.condition .staicon {
  width: 6.26667rem;
  height: 5.46667rem;
  margin: 0.50667rem auto 0.56rem;
  text-align: center;
}
.condition .staicon> div {
  padding-top: 2.66667rem;
  font-weight: bold;
  font-size: 0.4rem;
  line-height: 0.4rem;
}
.condition .staicon .points {
  align-items: flex-end;
}
.condition .staicon .points span {
  font-size: 0.93333rem;
  font-weight: bold;
  line-height: 0.74667rem;
}
.condition .staicon .sta {
  color: #56AF81;
  margin-top: 0.26667rem;
}
.condition .ul {
  text-align: center;
  height: 2.24rem;
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #626262;
  line-height: 0.32rem;
  box-shadow: 0 0.02667rem 0.26667rem 0 rgb(0 0 0 8%);
  border-radius: 0.26667rem;
}
.condition .ul .li {
  width: 100%;
}
.condition .ul .li> div:nth-child(1){
  font-size: 0.48rem;
  font-weight: bold;
  color: #62B677;
  line-height: 0.48rem;
  margin-bottom: 0.29333rem;
}

.evaluate {
  color: #323232;
  line-height: 0.34667rem;
  position: relative;
  font-size: .35rem;
}
.evaluate .toptitle {
  font-size: 0.4rem;
  font-weight: bold;
  padding: 0.88rem 0.34667rem 0.72rem;
}
.evaluate .main {
  font-weight: 400;
  padding: 0 0.69333rem;
}
.evaluate .time {
  padding: 0.74667rem 0.4rem 0.69333rem;
  text-align: right;
}
.evaluate .staicon {
  position: absolute;
  width: 2.26667rem;
  height: 2.26667rem;
  right: 0.61333rem;
  bottom: 0.34667rem;
  margin: 0;
}

.table {
  padding: 0 0.34667rem;
  margin: 0 auto;
}
.table .ul {
  display: -webkit-box;
  overflow-x: auto;
  font-size: 0.4rem;
  font-weight: 400;
  color: #626262;
  line-height: 0.37333rem;
}
.table .ul .li {
  height: 1.6rem;
  width: 25%;
}
.table .ul .li.act {
  color: #F95F5F;
  font-weight: bold;
  position: relative;
}
.table .ul .li.act span {
  width: 0.64rem;
  height: 0.08rem;
  background: #F95F5F;
  border-radius: 0.05333rem;
  position: absolute;
  bottom: 0.26667rem;
}
.table .detail2 {
  background: #FFFFFF;
  box-shadow: 0 0.02667rem 0.26667rem 0 rgb(0 0 0 8%);
  border-radius: 0.13333rem;
  padding: 0 0.24rem;
  font-size: 0.34667rem;
  font-weight: 400;
  color: #323232;
  line-height: 0.34667rem;
}
.table .detail2 .one {
  height: 1.6rem;
  font-size: 0.37333rem;
  font-weight: bold;
}
.table .detail2 .one span {
  font-size: 0.26667rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #D81E06;
  line-height: 0.26667rem;
  padding: 0.08rem 0.21333rem;
  background: rgba(216, 30, 6, 0.2);
  border: 0.02667rem solid rgba(216, 30, 6, 0.2);
  border-radius: 0.10667rem;
}
.table .detail2 .two {
  height: 1.33333rem;
  border-top: 0.02667rem solid #EAEAEA;
  position: relative;
}
.table .detail2 .two .err {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.05333rem;
}
.table .detail2 .two> div:nth-child(2) {
  color: #DF0000
}

.signature {
  margin: 0.26667rem 0.34667rem 0;
  background: #fff;
  box-shadow: 0 0.02667rem 0.26667rem 0 rgb(0 0 0 8%);
  border-radius: 0.13333rem;
  overflow: hidden;
}
.signature .title {
  font-size: 0.4rem;
  font-weight: bold;
  color: #323232;
  line-height: 0.4rem;
  padding-left: 0.4rem;
  height: 1.33333rem;
}
.signature img {
  width: 8.5rem;
  min-height: 5rem;
  background: #F8F8F8;
  border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
  border: 0.01rem solid #E4E4E4;
}

.tip {
  font-size: 0.26667rem;
  font-weight: 400;
  color: #626262;
  line-height: 0.29333rem;
  height: 1.2rem;
  margin: 0 0.34667rem;
}
.pageTit {
  font-size: 0.4rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #323232;
  line-height: .56rem;
  padding: .6rem .2rem 0;
}
.box {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0rem 0.05rem 0.38rem 0.01rem rgba(162,164,183,0.06);
  border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
  font-size: 0.28rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #626262;
  line-height: 0.38rem;
  margin: .14rem auto .38rem;
}
.box .name {
  font-size: 0.4rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 0.56rem;
}
.box .intip {
  margin-top: .05rem;
}
.box .btn {
  height: 1.2rem;
  font-size: 0.3rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #323232;
  line-height: 0.4rem;
}
.box .btn> div {
  width: 100%;
  cursor: pointer;
}

.box2 {
  background: #FFFFFF;
  border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
  font-size: 0.33rem;
  font-weight: 400;
  color: #626262;
  line-height: .33rem;
}
.box2 .tabTit {
  padding: .5rem 0 .6rem;
}
.box2 .tabTit div {
  width: 1.5rem;
  height: 0.66rem;
  background: #F6F6F6;
  border-radius: 0.34rem;
  margin-left: .25rem;
}
.box2 .tabTit div.act {
  color: #FFFFFF;
  background: linear-gradient(130deg, #F98054 0%, #FF6363 100%);
}
.box2 .tabTit div:nth-child(1) {
  margin-left: 0;
}
.box2 .seeMore {
  font-size: 0.33rem;
  font-weight: 400;
  color: #626262;
  line-height: .46rem;
  padding: .5rem 0 .4rem;
  cursor: pointer;
}
</style>
